import { ELCLogger, TriggerType } from '@estee/elc-logging';
import { root } from '@estee/elc-universal-utils';

type ObjectWithNumbers = { [key: string]: number };

interface ImPulse {
    sendMetric(name: string, value: number): void;
    sendMetrics(metrics: ObjectWithNumbers): void;
    sendTimer(name: string, value: number): void;
    sendTimers(metrics: ObjectWithNumbers): void;
}

declare global {
    namespace NodeJS {
        interface Global {
            BOOMR: undefined;
        }
    }
    interface Window {
        BOOMR?: ImPulse;
    }
}

export class mPulse {
    constructor(private readonly logger: ELCLogger) {}

    private emptyFunction = (fnName: string) => (...args: any) => {
        this.logger.warning({
            triggerType: TriggerType.other,
            message: `Function ${fnName} was not found on root.BOOMR`,
            payload: {
                context: {
                    mPulse: root.BOOMR,
                    arguments: JSON.stringify(args)
                }
            }
        });
    };

    sendMetric = (...args: Parameters<ImPulse['sendMetric']>) =>
        (root.BOOMR?.sendMetric || this.emptyFunction('sendMetric'))(...args);

    sendMetrics = (...args: Parameters<ImPulse['sendMetrics']>) =>
        (root.BOOMR?.sendMetrics || this.emptyFunction('sendMetrics'))(...args);

    sendTimer = (...args: Parameters<ImPulse['sendTimer']>) =>
        (root.BOOMR?.sendTimer || this.emptyFunction('sendTimer'))(...args);

    sendTimers = (...args: Parameters<ImPulse['sendTimers']>) =>
        (root.BOOMR?.sendTimers || this.emptyFunction('sendTimers'))(...args);
}
